import React, { useEffect } from 'react';

import AnnouncementBar from '../../Components/AnnouncementBar/AnnouncementBar';
import NavBar from '../../Components/NavBar/NavBar';
import Footer from '../../Components/Footer/Footer';
import QuickContact from '../../Components/QuickContact/QuickContact';

import Home from '../Home/Home';
import About from '../About/About';
import Facility from '../Facility/Facility';
import Menu from '../Menu/Menu';
import Gallery from '../Gallery/Gallery';
import Reviews from '../Reviews/Reviews';
import Contact from '../Contact/Contact';

import { apiTrackVisit } from '../../services/api';

const MainPage = () => {
    useEffect(() => {
        // Track customer visit automatically
        apiTrackVisit();
    }, []);

    return (
        <div className="main-app-container">
            {/* Top Announcement Bar */}
            <AnnouncementBar />

            {/* Sticky Header Navigation */}
            <NavBar />

            {/* Main Sections */}
            <main>
                <Home />
                <About />
                <Facility />
                <Menu />
                <Gallery />
                <Reviews />
                <Contact />
            </main>

            {/* Footer */}
            <Footer />

            {/* Floating Quick Contact Widget */}
            <QuickContact />
        </div>
    );
};

export default MainPage;